function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Splacanie-uverov-2_1_2",
  transform: "translate(-1199.000000, -678.000000)",
  stroke: "#F71D1D",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(111.000000, 298.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(1081.000000, 373.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "x",
  transform: "translate(8.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 0,
  x2: 0,
  y2: 8,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 0,
  x2: 8,
  y2: 8,
  id: "Path"
}))))));

var SvgSmallCross = function SvgSmallCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmallCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/small-cross.78ca0c2f.svg";
export { ForwardRef as ReactComponent };